import { useLang } from "@/i18n/LanguageContext";

const ABOUT_IMG =
  "https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzZ8MHwxfHNlYXJjaHwyfHxidXNpbmVzcyUyMG1lZXRpbmclMjBkb2N1bWVudHN8ZW58MHx8fHwxNzgxMjIwODQ2fDA&ixlib=rb-4.1.0&q=85";

export default function TrustIntro() {
  const { t } = useLang();
  const a = t.about;
  return (
    <section data-testid="trust-intro-section" className="section-y bg-white border-y border-ink-900/8 relative">
      <div className="container-x grid lg:grid-cols-12 gap-14 items-center">
        <div className="lg:col-span-6 relative">
          <div className="absolute -top-5 -left-5 w-24 h-24 border-l-2 border-t-2 border-brand-500 hidden sm:block" />
          <div className="absolute -bottom-5 -right-5 w-24 h-24 border-r-2 border-b-2 border-brand-500 hidden sm:block" />
          <img
            src={ABOUT_IMG}
            alt="Tax advisors reviewing financial documents at a boardroom table"
            className="w-full h-[460px] object-cover"
            loading="lazy"
          />
        </div>

        <div className="lg:col-span-6">
          <div className="flex items-center gap-3 mb-6">
            <span className="hairline" />
            <span className="text-overline">{a.overline}</span>
          </div>
          <h2 className="font-display font-extrabold text-3xl sm:text-4xl lg:text-5xl leading-tight text-ink-900 tracking-tight">
            {a.h2a} <span className="text-brand-500">{a.h2accent}</span>{a.h2b}
          </h2>
          <p className="mt-6 text-base sm:text-lg text-ink-500 leading-relaxed">{a.p1}</p>
          <p className="mt-4 text-base text-ink-500 leading-relaxed">{a.p2}</p>

          <div className="grid grid-cols-2 sm:grid-cols-4 gap-x-8 gap-y-8 mt-10 pt-10 border-t border-ink-900/8">
            {a.stats.map((s, i) => (
              <div key={i} data-testid={`stat-${i + 1}`}>
                <div className="font-display font-extrabold text-3xl text-ink-900">{s.v}</div>
                <div className="text-xs text-ink-500 mt-2 uppercase tracking-widest leading-snug">{s.k}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
